var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.68b95cd2bc75587ccae7f7c974242308.svg#n';
                    var viewUrl = 'sprites.68b95cd2bc75587ccae7f7c974242308.svg#view-n';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };